import { formatRate } from '../../utils/formatOpportunityValues';
export const discountLeakEvidenceLines = (evidence, texts, locale)=>[
        texts.currentDiscount({
            rate: formatRate(evidence.currentDiscountRate, locale)
        }),
        texts.maxDiscount({
            rate: formatRate(evidence.maxDiscountRate, locale)
        }),
        texts.discountedInvoiceCount({
            count: evidence.discountedInvoiceCount
        })
    ];
